import { Flex, Typography, Button, Icons } from 'components';
import { ReactElement } from 'react';

import styled from 'styled-components';

interface QrcodeProps {
  onClick: () => void;
  qrcode: any;
}

const Icon = styled(Icons)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.gray_300};
  margin-right: 8px;
`;

const Qrcode = ({ onClick, qrcode }: QrcodeProps): ReactElement => {
  return (
    <Flex
      alignSelf="center"
      flexDirection="column"
      padding={24}
      alignItems="center"
      justifyContent="space-between"
      maxWidth={600}
      backgroundColor="white"
    >
      <Flex justifyContent="center">
        <Flex marginBottom={16} justifyContent="center">
          <Typography fontWeight="bold" color="dark_350" textAlign="center">
            Leia o código QR com o aplicativo autenticador
          </Typography>
        </Flex>
        <Flex maxWidth={500} justifyContent="center">
          <Flex marginBottom={16} justifyContent="center">
            <Typography type="type1" color="dark_350" textAlign="center">
              Abra o aplicativo autenticador que você acabou de baixar e use-o para ler o código QR abaixo.
            </Typography>
          </Flex>
        </Flex>

        <Flex>
          <img src={qrcode} alt="Minha Imagem" />
        </Flex>

        {/** 
       * TODO FAZER QUANDO A WIKI ESTIVER PRONTA <Flex marginY={32}>
          <Link to={``}>
            <Typography fontWeight="bold" type="type1" color="primary_400">
              Dúvidas sobre a autenticação em dois fatores? Acesse o FAQ
            </Typography>
          </Link>
  </Flex>*/}

        <Flex flexDirection="row" flexWrap="nowrap" alignItems="flex-start" marginTop={48} marginBottom={32}>
          <Icon icon="info" style={{ flexShrink: 0 }} />

          <Flex maxWidth={430}>
            <Typography type="type1" color="light4">
              Nunca solicitamos códigos por telefone ou aplicativos de mensagem. Não compartilhe seu código com outras pessoas.
            </Typography>
          </Flex>
        </Flex>

        {/* <Flex marginTop={32} marginBottom={32} flexDirection="row" justifyContent="space-between" alignItems="center">
          <Flex>
            <Icon icon="info" />
          </Flex>

          <Flex maxWidth={500}>
            <Typography type="type1" color="light4">
              A MELVER nunca solicita códigos por telefone ou aplicativos de mensagem. Não compartilhe seu código com outras pessoas.
            </Typography>
          </Flex>
        </Flex> */}
      </Flex>

      <Flex>
        <Button type="button" p={24} bg="primary_400" color="white" colorHover="white" size="small" onClick={onClick}>
          Li o código e quero continuar
        </Button>
      </Flex>
    </Flex>
  );
};

export default Qrcode;
